// extracted by mini-css-extract-plugin
export default {"orange":"translationStatus-module__orange__lVuv8","brown":"translationStatus-module__brown__ACQmW"};